// extracted by mini-css-extract-plugin
export default {"button":"AppBarIcons_button__2fI2g"};